/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApplicationUserFromJSON, ApplicationUserToJSON, ProtocolFromJSON, ProtocolToJSON, } from './';
export function ProtocolDamageModelFromJSON(json) {
    return ProtocolDamageModelFromJSONTyped(json, false);
}
export function ProtocolDamageModelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
        'createdBy': !exists(json, 'createdBy') ? undefined : ApplicationUserFromJSON(json['createdBy']),
        'createdById': !exists(json, 'createdById') ? undefined : json['createdById'],
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : ApplicationUserFromJSON(json['modifiedBy']),
        'modifiedById': !exists(json, 'modifiedById') ? undefined : json['modifiedById'],
        'protocol': !exists(json, 'protocol') ? undefined : ProtocolFromJSON(json['protocol']),
        'protocolId': !exists(json, 'protocolId') ? undefined : json['protocolId'],
        'file': !exists(json, 'file') ? undefined : json['file'],
        'fileId': !exists(json, 'fileId') ? undefined : json['fileId'],
    };
}
export function ProtocolDamageModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdBy': ApplicationUserToJSON(value.createdBy),
        'modifiedBy': ApplicationUserToJSON(value.modifiedBy),
        'protocol': ProtocolToJSON(value.protocol),
        'protocolId': value.protocolId,
        'file': value.file,
        'fileId': value.fileId,
    };
}
